<template>
    <div v-if="getUserPermissions().view_campaign_groupings" id="admin_campaign_groupings_page" class="container-fluid">
        <button v-if="getUserPermissions().create_campaign_groupings" @click="openAddNewCampaignGroupingModal" type="button" class="btn btn-secondary main-button pull-right" data-toggle="modal" data-target="#add_new_campaign_grouping_modal">+ Add New Grouping</button>

        <div v-if="getUserPermissions().create_campaign_groupings" class="modal fade" id="add_new_campaign_grouping_modal" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog modal-xl" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Add New Grouping</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>

                    <div class="modal-body">
                        <form>
                            <div class="form-group">
                                <label for="grouping_name">GROUPING NAME</label>
                                <input v-model="grouping_name" type="text" class="form-control col-md-5 col-lg-4 col-xl-3" id="grouping_name" autofocus>
                            </div>

                            <hr>

                            <div class="row">
                                <div class="col-4">
                                    <div class="form-group">
                                        <label for="segment_name">SEGMENT NAME</label>
                                        <input v-model="segment_name" type="text" class="form-control" id="segment_name">
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-4">
                                    <div class="form-group">
                                        <label for="starts_with">STARTS WITH</label>
                                        <input v-model="starts_with" type="text" class="form-control" id="starts_with">
                                    </div>
                                </div>

                                <div class="col-4">
                                    <div class="form-group">
                                        <label for="ends_on">ENDS ON</label>
                                        <input v-model="ends_on" type="text" class="form-control" id="ends_on">
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-4">
                                    <div class="form-group">
                                        <label for="contains">CONTAINS</label>
                                        <input v-model="contains" type="text" class="form-control" id="contains">
                                    </div>
                                </div>

                                <div class="col-4">
                                    <div class="form-group">
                                        <label for="does_not_contain">DOES NOT CONTAIN</label>
                                        <input v-model="does_not_contain" type="text" class="form-control" id="does_not_contain">
                                    </div>
                                </div>
                            </div>

                            <hr>

                            <div class="row margin-top20">
                                <div class="col-12 margin-bottom10">
                                    <label><p-input type="checkbox" class="p-switch p-slim clients-all" @change="selectAllCampaignGroupingClients" :checked="selected_clients.length === clients.length">Select all</p-input></label>
                                </div>

                                <template v-for="client in clients">
                                    <div class="col-4 margin-bottom5">
                                        <label><p-input v-model="selected_clients" class="p-default p-curve single" type="checkbox" :value="client.id"> {{ client.name }}</p-input></label>
                                    </div>
                                </template>
                            </div>
                        </form>
                    </div>

                    <div class="modal-footer">
                        <button type="button" class="btn" data-dismiss="modal">Cancel</button>
                        <button @click="addNewCampaignGrouping" :disabled="add_new_campaign_grouping_validate" type="button" class="btn btn-success">Add</button>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="getUserPermissions().edit_campaign_groupings" class="modal fade" id="update_campaign_grouping_modal" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog modal-xl" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Update Grouping</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>

                    <div class="modal-body">
                        <form>
                            <div class="form-group">
                                <label for="update_grouping_name">GROUPING NAME</label>
                                <input v-model="update_grouping_name" type="text" class="form-control col-md-5 col-lg-4 col-xl-3" id="update_grouping_name" autofocus>
                            </div>

                            <hr>

                            <div class="row margin-top20">
                                <div class="col-12 margin-bottom10">
                                    <label><p-input type="checkbox" class="p-switch p-slim clients-all" @change="selectAllCampaignGroupingClientsForUpdate" :checked="update_selected_clients.length === clients.length">Select all</p-input></label>
                                </div>

                                <template v-for="client in clients">
                                    <div class="col-4 margin-bottom5">
                                        <label><p-input v-model="update_selected_clients" class="p-default p-curve single" type="checkbox" :value="client.id"> {{ client.name }}</p-input></label>
                                    </div>
                                </template>
                            </div>
                        </form>
                    </div>

                    <div class="modal-footer">
                        <button type="button" class="btn" data-dismiss="modal">Cancel</button>
                        <button @click="updateGrouping" :disabled="update_campaign_grouping_validate" type="button" class="btn btn-success">Update</button>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="getUserPermissions().create_campaign_groupings" class="modal fade" id="add_new_segment_modal" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog modal-xl" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Add New Segment</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>

                    <div class="modal-body">
                        <form>
                            <div class="row">
                                <div class="col-4">
                                    <div class="form-group">
                                        <label for="segment_name_2">SEGMENT NAME</label>
                                        <input v-model="segment_name" type="text" class="form-control" id="segment_name_2">
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-4">
                                    <div class="form-group">
                                        <label for="starts_with_2">STARTS WITH</label>
                                        <input v-model="starts_with" type="text" class="form-control" id="starts_with_2">
                                    </div>
                                </div>

                                <div class="col-4">
                                    <div class="form-group">
                                        <label for="ends_on_2">ENDS ON</label>
                                        <input v-model="ends_on" type="text" class="form-control" id="ends_on_2">
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-4">
                                    <div class="form-group">
                                        <label for="contains_2">CONTAINS</label>
                                        <input v-model="contains" type="text" class="form-control" id="contains_2">
                                    </div>
                                </div>

                                <div class="col-4">
                                    <div class="form-group">
                                        <label for="does_not_contain_2">DOES NOT CONTAIN</label>
                                        <input v-model="does_not_contain" type="text" class="form-control" id="does_not_contain_2">
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>

                    <div class="modal-footer">
                        <button type="button" class="btn" data-dismiss="modal">Cancel</button>
                        <button @click="addNewSegment" :disabled="add_new_segment_validate" type="button" class="btn btn-success">Add</button>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="getUserPermissions().create_campaign_groupings" class="modal fade" id="update_segment_modal" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog modal-xl" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Update Segment</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>

                    <div class="modal-body">
                        <form>
                            <div class="row">
                                <div class="col-4">
                                    <div class="form-group">
                                        <label for="segment_name_3">SEGMENT NAME</label>
                                        <input v-model="update_segment_name" type="text" class="form-control" id="segment_name_3">
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-4">
                                    <div class="form-group">
                                        <label for="starts_with_3">STARTS WITH</label>
                                        <input v-model="update_segment_starts_with" type="text" class="form-control" id="starts_with_3">
                                    </div>
                                </div>

                                <div class="col-4">
                                    <div class="form-group">
                                        <label for="ends_on_3">ENDS ON</label>
                                        <input v-model="update_segment_ends_on" type="text" class="form-control" id="ends_on_3">
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-4">
                                    <div class="form-group">
                                        <label for="contains_3">CONTAINS</label>
                                        <input v-model="update_segment_contains" type="text" class="form-control" id="contains_3">
                                    </div>
                                </div>

                                <div class="col-4">
                                    <div class="form-group">
                                        <label for="does_not_contain_3">DOES NOT CONTAIN</label>
                                        <input v-model="update_segment_does_not_contain" type="text" class="form-control" id="does_not_contain_3">
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>

                    <div class="modal-footer">
                        <button type="button" class="btn" data-dismiss="modal">Cancel</button>
                        <button @click="updateSegment" :disabled="update_segment_validate" type="button" class="btn btn-success">Update</button>
                    </div>
                </div>
            </div>
        </div>

        <v-client-table ref="campaign_groupings_datatable" :data="tableData" :columns="columns" :options="options">
            <template slot="grouping_name" slot-scope="props" class="text-right">
                <span>{{ props.row.grouping_name }}</span>
                <i v-if="getUserPermissions().edit_campaign_groupings" @click="openUpdateCampaignGroupingModal(props.row)" class="fa fa-pencil margin-left10" aria-hidden="true" data-toggle="modal" data-target="#update_campaign_grouping_modal"></i>
            </template>

            <template v-slot:child_row="props">
                <div v-for="segment in props.row.segments" class="margin-left20 margin-bottom10 segment">
                    <i class="fa fa-circle" aria-hidden="true"></i>
                    <span class="child-row" v-html="getSegmentText(segment)"></span>
                    <i @click="openUpdateSegmentModal(segment)" class="fa fa-pencil margin-left10" aria-hidden="true" data-toggle="modal" data-target="#update_segment_modal"></i>
                    <i @click="deleteSegment(segment.id)" class="fa fa-trash margin-left10" aria-hidden="true"></i>
                </div>
            </template>

            <div slot="actions" slot-scope="props" class="text-right">
                <button @click="expandCollapseRow(props.row.id, $event)" class="btn btn-info reverse view-button">View</button>
                <button v-if="getUserPermissions().create_campaign_groupings" @click="openAddNewSegmentModal(props.row.id)" class="btn btn-info reverse" data-toggle="modal" data-target="#add_new_segment_modal">+ Add Segment</button>
                <button v-if="getUserPermissions().delete_campaign_groupings" @click="deleteCampaignGrouping(props.row.id)" class="btn btn-danger reverse">Delete</button>
            </div>
        </v-client-table>

        <div class="text-center">
            <button @click="$router.go(-1)" type="button" class="btn btn-info">Back</button>
        </div>
    </div>
</template>

<script>
    export default {
        created() {
            this.fetchServerData();

            const self = this;

            $(document).off('hidden.bs.modal', '#add_new_campaign_grouping_modal').on('hidden.bs.modal', '#add_new_campaign_grouping_modal', function() {

            });
        },

        data() {
            return {
                grouping_name:    '',
                segment_name:     '',
                starts_with:      '',
                ends_on:          '',
                contains:         '',
                does_not_contain: '',
                clients:          [],
                selected_clients: [],

                // Add New Segment
                add_new_segment_grouping_id: '',

                // Update Grouping
                update_grouping_id:      '',
                update_grouping_name:    '',
                update_selected_clients: [],

                // Update Segment
                update_segment_id:               '',
                update_segment_name:             '',
                update_segment_starts_with:      '',
                update_segment_ends_on:          '',
                update_segment_contains:         '',
                update_segment_does_not_contain: '',

                columns: ['grouping_name', 'segments_count', 'actions'],
                tableData: [],
                options: {
                    headings: {
                        grouping_name:  'Grouping Name',
                        segments_count: 'No. of segments',
                        actions:        ''
                    },
                    sortable: ['grouping_name', 'segments_count'],

                    perPage: 20,
                    perPageValues: [],
                    texts: {
                        count: 'Showing {from} to {to} of {count} groupings|{count} groupings|One grouping',
                        filter: '',
                        filterPlaceholder: 'Search groupings...',
                        noResults: 'No matching groupings'
                    },
                    skin: 'table'
                }
            }
        },

        methods: {
            fetchServerData() {
                axios.all([
                    axios.get('/api/clients'),
                    axios.get('/api/admin/campaign-groupings'),
                ])
                .then(axios.spread((clients, campaignGroupings) => {
                    this.clients   = _.orderBy(clients.data, ['name'], ['asc']);
                    this.tableData = campaignGroupings.data;
                }));
            },

            expandCollapseRow(rowId, event) {
                this.$refs.campaign_groupings_datatable.toggleChildRow(rowId);

                this.$nextTick(() => {
                    this.updateViewHideText();
                });
            },

            updateViewHideText() {
                $(this.$refs.campaign_groupings_datatable.$el).find('tbody tr').each(function() {
                    if ($(this).find('td:first span').hasClass('VueTables__child-row-toggler--closed')) {
                        $(this).find('.view-button').text('View');
                    } else {
                        $(this).find('.view-button').text('Hide');
                    }
                });
            },

            getSegmentText(segment) {
                let text = '<b>' + segment.segment_name + '</b> - ';

                if (segment.starts_with) {
                    text += 'starts with <u><i>'+ segment.starts_with.replace(/\|/g, ', ') + '</i></u>';
                }

                if (segment.ends_on) {
                    if (segment.starts_with) {
                        text += ' | ';
                    }

                    text += 'ends on <u><i>' + segment.ends_on.replace(/\|/g, ', ') + '</i></u>';
                }

                if (segment.contains) {
                    if (segment.starts_with || segment.ends_on) {
                        text += ' | ';
                    }

                    text += 'contains <u><i>' + segment.contains.replace(/\|/g, ', ') + '</i></u>';
                }

                if (segment.does_not_contain) {
                    if (segment.starts_with || segment.ends_on || segment.contains) {
                        text += ' | ';
                    }

                    text += 'does not contain <u><i>' + segment.does_not_contain.replace(/\|/g, ', ') + '</i></u>';
                }

                return text.replace(/,\s+$/, '', '');
            },

            selectAllCampaignGroupingClients(isChecked) {
                this.selected_clients = [];

                if (isChecked) {
                    _.each(this.clients, client => {
                        this.selected_clients.push(client.id);
                    });
                }
            },

            selectAllCampaignGroupingClientsForUpdate(isChecked) {
                this.update_selected_clients = [];

                if (isChecked) {
                    _.each(this.clients, client => {
                        this.update_selected_clients.push(client.id);
                    });
                }
            },

            openAddNewCampaignGroupingModal() {
                this.segment_name     = '';
                this.starts_with      = '';
                this.ends_on          = '';
                this.contains         = '';
                this.does_not_contain = '';
                this.grouping_name    = '';

                this.selected_clients = [];
                _.each(this.clients, client => {
                    this.selected_clients.push(client.id);
                });
            },

            addNewCampaignGrouping() {
                $('#add_new_campaign_grouping_modal').modal('hide');

                axios.post('/api/admin/campaign-groupings', {
                    grouping_name:    this.grouping_name,
                    segment_name:     this.segment_name,
                    starts_with:      this.starts_with,
                    ends_on:          this.ends_on,
                    contains:         this.contains,
                    does_not_contain: this.does_not_contain,
                    selected_clients: JSON.stringify(this.selected_clients)
                }).then(() => {
                    this.$notify({
                        type: 'success',
                        text: 'Campaign grouping has been successfully added.'
                    });

                    this.fetchServerData();
                });
            },

            openUpdateCampaignGroupingModal(row) {
                this.update_grouping_id      = row.id;
                this.update_grouping_name    = row.grouping_name;
                this.update_selected_clients = row.selected_clients;
            },

            updateGrouping() {
                $('#update_campaign_grouping_modal').modal('hide');

                axios.put(`/api/admin/campaign-groupings/${this.update_grouping_id}`, {
                    grouping_name:    this.update_grouping_name,
                    selected_clients: JSON.stringify(this.update_selected_clients)
                }).then(() => {
                    this.$notify({
                        type: 'success',
                        text: 'Campaign grouping has been successfully updated.'
                    });

                    this.fetchServerData();
                });
            },

            openAddNewSegmentModal(id) {
                this.segment_name                = '';
                this.starts_with                 = '';
                this.ends_on                     = '';
                this.contains                    = '';
                this.does_not_contain            = '';
                this.add_new_segment_grouping_id = id;
            },

            addNewSegment() {
                $('#add_new_segment_modal').modal('hide');

                axios.post(`/api/admin/campaign-groupings/${this.add_new_segment_grouping_id}/segments`, {
                    segment_name:     this.segment_name,
                    starts_with:      this.starts_with,
                    ends_on:          this.ends_on,
                    contains:         this.contains,
                    does_not_contain: this.does_not_contain
                }).then(() => {
                    this.$notify({
                        type: 'success',
                        text: 'Segment has been successfully added.'
                    });

                    this.fetchServerData();
                });
            },

            openUpdateSegmentModal(segment) {
                this.update_segment_id               = segment.id;
                this.update_segment_name             = segment.segment_name;
                this.update_segment_starts_with      = segment.starts_with;
                this.update_segment_ends_on          = segment.ends_on;
                this.update_segment_contains         = segment.contains;
                this.update_segment_does_not_contain = segment.does_not_contain;
            },

            updateSegment() {
                $('#update_segment_modal').modal('hide');

                axios.put(`/api/admin/campaign-groupings/segments/${this.update_segment_id}`, {
                    segment_name:     this.update_segment_name,
                    starts_with:      this.update_segment_starts_with,
                    ends_on:          this.update_segment_ends_on,
                    contains:         this.update_segment_contains,
                    does_not_contain: this.update_segment_does_not_contain
                }).then(() => {
                    this.$notify({
                        type: 'success',
                        text: 'Segment has been successfully updated.'
                    });

                    this.fetchServerData();
                });
            },

            deleteCampaignGrouping(id) {
                this.confirmation('Are you sure you want to delete this grouping?', () => {
                    axios.delete(`/api/admin/campaign-groupings/${id}`).then(() => {
                        this.$notify({
                            type: 'success',
                            text: 'Campaign grouping has been successfully removed.'
                        });

                        this.fetchServerData();
                    });
                });
            },

            deleteSegment(id) {
                this.confirmation('Are you sure you want to delete this segment?', () => {
                    axios.delete(`/api/admin/campaign-groupings/segments/${id}`).then(() => {
                        this.$notify({
                            type: 'success',
                            text: 'Segment has been successfully removed.'
                        });

                        this.fetchServerData();
                    });
                });
            }
        },

        computed: {
            add_new_campaign_grouping_validate() {
                return !(this.grouping_name && this.selected_clients.length > 0 && this.segment_name && (
                    this.starts_with || this.ends_on || this.contains || this.does_not_contain
                ));
            },

            update_campaign_grouping_validate() {
                return !(this.update_grouping_name && this.update_selected_clients.length > 0);
            },

            add_new_segment_validate() {
                return !(this.segment_name && (
                    this.starts_with || this.ends_on || this.contains || this.does_not_contain
                ));
            },

            update_segment_validate() {
                return !(this.update_segment_name && (
                    this.update_segment_starts_with || this.update_segment_ends_on || this.update_segment_contains || this.update_segment_does_not_contain
                ));
            }
        }
    }
</script>

<style lang="scss">
    @import '~@/_variables.scss';

    #admin_campaign_groupings_page {
        .VueTables__table {
            table-layout: fixed;
        }

        .VueTables__table td {
            padding-top: .5rem;
            padding-bottom: .5rem;
        }

        .VueTables__child-row td {
            padding-top: 0;
        }

        table {
            .fa-circle {
                color: #37a8cd;
                margin-right: .5rem;
                font-size: 1.2rem;
                position: relative;
                top: -0.1rem;
            }

            .fa-pencil {
                border-radius: 20%;
                padding: .4rem;
                cursor: pointer;
                box-shadow: 0 0 .3rem #71d2fd;
                color: #049bdd;
                font-size: 1.3rem;
            }

            .fa-trash {
                border-radius: 20%;
                padding: .4rem;
                cursor: pointer;
                box-shadow: 0 0 .3rem #a94442;
                color: #a94442;
                font-size: 1.3rem;
            }

            th:first-child {
                width: .1rem;
                padding: 0;
            }

            .segment {
                color: #666;
            }
        }

        #add_new_campaign_grouping_modal,
        #update_campaign_grouping_modal,
        #add_new_segment_modal,
        #update_segment_modal {
            label {
                font-weight: 500;
            }

            .pretty.p-default input:checked ~ .state label::after {
                background-color: $info !important;
            }

            .pretty.p-switch input:checked ~ .state label::after {
                background-color: $info !important;
            }
        }
    }
</style>
